import { useEffect, useRef } from "react";

// func will run when deps changes but not on initial render (works like componentDidUpdate)
const useDidUpdateEffect = (func, deps) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
};

export default useDidUpdateEffect;
